export const formatPrice = (price: number, config: any = {}) => {
	return new Intl.NumberFormat('cs-CZ', {
		style: 'currency',
		currency: 'CZK',
		...config,
	}).format(price)
}
